import React from 'react'
import { IntlProvider, addLocaleData } from 'react-intl'

// Locale data
import enData from 'react-intl/locale-data/en'
import itData from 'react-intl/locale-data/it'

import en1 from '../i18n/en/messages.json'
import en2 from '../i18n/en/form.json'
import en3 from '../i18n/en/errors.json'
import it1 from '../i18n/messages.json'
import it2 from '../i18n/form.json'
import it3 from '../i18n/errors.json'
const messages = { en: { ...en1, ...en2, ...en3 }, it: { ...it1, ...it2, ...it3 } }
addLocaleData([...enData, ...itData])


const IntlWrapper = ({ locale, children }) => (
  <IntlProvider locale={locale} messages={messages[locale]} defaultLocale="it">
    {children}
  </IntlProvider>
);

export default IntlWrapper;